export const getDateObjectsArr = (datesFromBackArr) => datesFromBackArr.map(dateArrElement=>new Date(dateArrElement.date))

